//react
import React from 'react';

//redux
import { connect } from 'react-redux';

//firebase
import { db } from 'assets/firebase';

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

//core
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";

//components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomSelect from "components/Select/Select.jsx";
import Button from "components/CustomButtons/Button.jsx";

// @material-ui/icons
import Edit from "@material-ui/icons/Edit";
import Task from "@material-ui/icons/AssignmentTurnedIn";

//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-127392840-1');

function Transition(props) {
    return <Slide direction="down" {...props} />;
  }
  
  class TaskEditor extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        modal: false,
        task: props.task
      };

      this.saveTask = this.saveTask.bind(this);
      this.updateTask = this.updateTask.bind(this);
    }

    handleClickOpen(modal) {
      var x = [];
      x[modal] = true;
      this.setState(x);
    }

    handleClose(modal) {
      var x = [];
      x[modal] = false;
      this.setState(x);
    }

    updateTask(property, value) {
      var obj = this.state.task;
      obj[property] = value;
      this.setState({task: obj});
    }

    saveTask() {
    
      db.updateTask(this.state.task.id, this.state.task).then(doc => {
        
        this.props.onChange();

        //finally...
        if(!this.state.task.id) { // i.e. if it's a new task

            this.updateTask("id",doc.id);

            ReactGA.event({
            category: 'Task',
            action: 'Created a New Task'
            });

            // reset to blank
            this.setState(
              {task:{
                Name: "",
                Description: "",
                Status: "open",
                Category: "",
                Owner: "",
                DueDate: "",
                id: null
              }
            });

        } else { // i.e. an existing school

            ReactGA.event({
              category: 'Task',
              action: 'Updated a Task'
            });
        }
      });
    }
        
    trim(value, maxLength) {
      if(value.length > maxLength)
          return value.substring(0,maxLength) + "...";
      else
          return value;
    }

    render() {

      const { classes } = this.props;

      return (
        <div>
          
          <IconButton
            aria-label="Edit"
            onClick={() => this.handleClickOpen("modal")}>
            <Edit
                className={
                    classes.tableActionButtonIcon + " " + classes.edit
                }
            />
          </IconButton>
          <Dialog
            classes={{
              root: classes.center,
              paper: classes.modal
            }}
            open={this.state.modal}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => this.handleClose("modal")}
            aria-labelledby="modal-slide-title"
            aria-describedby="modal-slide-description">

            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{backgroundColor:"#efefef"}} >

              <GridContainer direction="row">
                <GridItem xs={12} sm={12} md={6}>
                  <h4 className={classes.modalTitle}>Edit Task</h4>
                </GridItem>
                <GridItem xs={12} sm={12} md={6} style={{textAlign:"right"}}>
                  
                </GridItem>
              </GridContainer>
            </DialogTitle>
            <DialogContent
              id="modal-slide-description"
              className={classes.modalBody}
              style={{backgroundColor:"#efefef"}}>
             <CustomTabs
                headerColor="success"
                tabs={[
                  {
                    tabName: "General",
                    tabIcon: Task,
                    tabContent: (
                      
                        <GridContainer direction="row">
                          <GridItem xs={12} sm={12} md={6}>
                            <CustomInput
                              labelText="Name"
                              value={this.state.task.Name}
                              inputProps={{ placeholder: "Name" }}
                              formControlProps={{ fullWidth: true }}
                              onChange={(e) => this.updateTask("Name", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <CustomSelect
                                labelText="Category"
                                value={this.state.task.Category}
                                inputProps={{
                                    placeholder: "Category"
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateTask("Category", e.target.value)}
                                options={[
                                  {key:"admin",label:"Admin"},
                                  {key:"content",label:"Content"},
                                  {key:"legal",label:"Legal"},
                                  {key:"marketing",label:"Marketing"},
                                  {key:"sales",label:"Sales"},
                                  {key:"bugs",label:"Website Bugs"},
                                  {key:"features",label:"Website Features"},
                                ]}
                               />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                            <CustomSelect
                                labelText="Owner"
                                value={this.state.task.Owner}
                                inputProps={{ placeholder: "Owner" }}
                                formControlProps={{ fullWidth: true }}
                                onChange={(e) => this.updateTask("Owner", e.target.value)}
                                options={[
                                  {key:"danna",label:"Danna"},
                                  {key:"michael",label:"Michael"},
                                  {key:"tanny",label:"Tanny"}
                                ]}
                               />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                          <CustomInput
                              labelText="Due Date"
                              value={this.state.task.DueDate}
                              inputProps={{ placeholder: "Due Date" }}
                              formControlProps={{ fullWidth: true }}
                              onChange={(e) => this.updateTask("DueDate", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={4}>
                            <CustomSelect
                                labelText="Status"
                                value={this.state.task.Status}
                                inputProps={{ placeholder: "Status" }}
                                formControlProps={{ fullWidth: true }}
                                onChange={(e) => this.updateTask("Status", e.target.value)}
                                options={[
                                  {key:"open",label:"Open"},
                                  {key:"inProgress",label:"In Progress"},
                                  {key:"complete",label:"Complete"}
                                ]}
                               />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                            <CustomInput
                              labelText="Description"
                              value={this.state.task.Description}
                              inputProps={{
                                  placeholder: "Description"
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateTask("Description", e.target.value)}
                            />
                          </GridItem>  
                        </GridContainer>
                    )
                  }
                ]}
              />

            </DialogContent>
            
            <DialogActions
              className={classes.modalFooter }
              style={{backgroundColor:"#efefef"}}>
              <Button
                    onClick={() => this.handleClose("modal")}
                  >
                    Cancel
                  </Button>
                  &nbsp;
                  <Button
                    onClick={() => {
                       this.saveTask();
                        this.handleClose("modal");
                      }}
                    color="success">
                    Save
                  </Button>
            </DialogActions>
          </Dialog>
        </div>
      );
    }
  }
  
const mapStateToProps = state => {
  return state;
}

TaskEditor = connect(mapStateToProps)(TaskEditor);
export default withStyles(modalStyle)(TaskEditor);


// WEBPACK FOOTER //
// ./src/components/TaskEditor/TaskEditor.jsx